import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import Cookies from "js-cookie";

const language = Cookies.get("language");

const resources = {
  en: {
    translation: en,
  },
};

// i18n
//   .use(LanguageDetector)
//   .use(initReactI18next)
//   .init({
//     fallbackLng: "en",
//     lng: language || "en",
//     debug: process.env.NODE_ENV === "development",
//     interpolation: {
//       escapeValue: false,
//     },

//     resources: resources,
//     maxRetries: 3,
//     interpolation: {
//     defaultVariables: {
//       name: ''
//     }
//   }
//   });

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    fallbackLng: "en",
    lng: language || "en",
    debug: process.env.NODE_ENV === "development",
    resources: resources,
    maxRetries: 3,

    interpolation: {
      escapeValue: false,
      defaultVariables: {
        report_name: "",
      },
    },
  });

export default i18n;
